import { Box, Flex, Icon, Tooltip } from '@chakra-ui/react';
import { TbTruck } from 'react-icons/tb';

interface SupplierCommunicationCountBadgeProps {
    count: number;
}

const SupplierCommunicationCountBadge = ({ count }: SupplierCommunicationCountBadgeProps) => {
    if (count <= 0) return null;

    return (
        <Tooltip label="Supplier Communications" placement="top">
            <Box
                position="relative"
                display="inline-flex"
                onClick={(e) => e.stopPropagation()}
            >
                <Icon
                    as={TbTruck as React.ElementType}
                    w="16px"
                    h="16px"
                    color="orange.500"
                    strokeWidth={2.25}
                />
                <Flex
                    position="absolute"
                    top="-4px"
                    right="-6px"
                    minW="14px"
                    h="14px"
                    px="3px"
                    borderRadius="full"
                    bg="orange.500"
                    color="white"
                    align="center"
                    justify="center"
                    fontSize="9px"
                    fontWeight="bold"
                    lineHeight="1"
                >
                    {count > 99 ? '99+' : count}
                </Flex>
            </Box>
        </Tooltip>
    );
};

export default SupplierCommunicationCountBadge;
